import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonAxiosResponse, thunkResponseHandler } from "common";
import { ActiveBranchResponse } from "./types";
import { BranchApi } from "./api";
import { isEnvProduction } from "common/constants/feature-toggles";

export const getActiveBranchesThunk = createAsyncThunk<
  CommonAxiosResponse<ActiveBranchResponse>
>("branch/getActiveBranchesThunk", async () => {
  const res: any = await BranchApi.getActiveBranches();
  // const activeBranchesData: ActiveBranchResponse = res?.data;
  
  // if (isEnvProduction && activeBranchesData?.data) {
  //   const activeBranches = activeBranchesData?.data || [];
  //   // Hide branch with id 3 in production
  //   activeBranchesData.data = activeBranches?.filter((branch) => {
  //     return branch.id !== 3;
  //   });
  // }

  // console.log("branches", res);

  const toThunk = await thunkResponseHandler(res);

  return toThunk;
});
